import { useQuery } from 'apollo-3';

import { myCourses } from 'GraphQL/query/Product.query';

export const MY_COURSES_MODE = {
  ALL: 'ALL',
  FULL: 'FULL',
  TRIAL: 'TRIAL',
};

const useAllMyCoursesData = ({ mode, ...options }) => {
  const { data, loading, error } = useQuery(myCourses, { variables: { mode }, ...options });

  return {
    data: data?.myCourses,
    loading,
    error,
  };
};

export default useAllMyCoursesData;
